export const BASE_MESSAGES = {
    CONFIRM_ELIMINAR: '¿Esta seguro de eliminar el registro?',
    CONFIRM_REGRESAR: 'Va a regresar a la pantalla anterior, los cambios no guardados se descartarán ¿Desea continuar?',
    CONFIRM_GUARDAR: '¿Esta seguro de guardar el registro?',
    ALERT_SELECCIONAR_UNIDADES: 'Debe seleccionar al menos una unidad didáctica'
}